<template>
  <div class="reclamations">
    <Tabs
      @tabActiveUpdate="$_reclamations_updateTab"
      :tabs="tabs"
      :active="tabActive"
      title="Рекламации поставщику"
      class="tab--table">
      <template v-if="load && statuses.length">
        <Journal
          v-if="tabActive === tabs[0].path"
          @clearParams="$_reclamations_clearParams"
          :paginationDesc="paginationDesc"
          :reclamations="supplier"
          :tab="tabActive" />
        <Journal
          v-if="tabActive === tabs[1].path"
          @clearParams="$_reclamations_clearParams"
          :paginationDesc="paginationDesc"
          :reclamations="supplierArchived"
          :tab="tabActive" />
      </template>
    </Tabs>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import mixinReclamations from "@/mixins/Account/reclamations.mixin";

export default {
  mixins: [
    mixinReclamations
  ],

  metaInfo() {
    return {
      title: `Рекламации поставщику - Личный кабинет дилера - ${this.getDealerName}`,
    }
  },

  data: () => ({
    paginationDesc: "Число записей на странице:"
  }),

  computed: {
    ...mapState({
      supplier: state => state.account.reclamations.supplier,
      supplierArchived: state => state.account.reclamations.supplierArchived,
    }),

    ...mapGetters('user', [
      'getDealerName',
    ]),
  },
};
</script>